<template>
  <div class="drawer-links-component">
    <v-list
      expand
      nav
      v-bind="$attrs"
      class="aside-list"
      v-on="$listeners"
    >
      <template v-for="(item, i) in items">
        <default-list-group
          v-if="item.items && userCanAccessToRoute(item)"
          :key="`group-${i}`"
          :item="item"
        />

        <default-list-item
          v-else-if="userCanAccessToRoute(item)"
          :key="`item-${i}`"
          :item="item"
          :collapsed="collapsed"
          :class="{ 'hide-on-mobile': item.hideOnMobile }"
        />
      </template>
    </v-list>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'
  import _ from 'lodash'
  // import Role from '@/models/enums/Roles'

  export default {
    name: 'Links',
    components: {
      DefaultListGroup: () => import('./ListGroup'),
      DefaultListItem: () => import('./ListItem'),
    },
    props: {
      // сайдбар свёрнут в полоску - от пунктов остаются иконки
      collapsed: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState({
        user: (state) => state.auth.initialState.user || {},
      }),

      // items в computed, а не data: баджи (ключ badge) должны
      // реактивно пересчитываться от Vuex-состояния
      items () {
        return [
          {
            title: 'Заказы',
            icon: 'shopping-basket',
            to: '/orders',
          },
          {
            title: 'Касса',
            icon: 'cash-register',
            to: '/administrator/cashier',
          },
          {
            title: 'График смен',
            icon: 'calendar-alt',
            to: '/administrator/shift-schedule',
          },
          {
            title: 'Карта курьеров',
            icon: 'map-marked-alt',
            hideOnMobile: false,
            to: '/geo/couriers-map',
          },
          {
            title: 'Филиалы',
            icon: 'store',
            hideOnMobile: false,
            to: '/call-center/filials',
            permissions: ['crm.callcenter-filials.view'],
          },
          {
            title: 'Меню филиала',
            icon: 'utensils',
            to: '/filial-menu',
            hideOnMobile: false,
          },
          {
            title: 'Стоп-лист',
            icon: 'hand-paper',
            to: '/stop-list',
            hideOnMobile: false,
            badge: 'stopList',
          },
          {
            title: 'Статистика',
            icon: 'chart-bar',
            to: '/stat',
            hideOnMobile: false,
            mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
          },
          {
            title: 'Справочники',
            icon: 'book',
            to: '/entities',
            permissions: [CRMPermission.ViewEntities],
            hideOnMobile: false,
          },
          {
            title: 'Настройки',
            icon: 'cog',
            to: '/settings',
            hideOnMobile: false,
            permissions: [CRMPermission.ViewSettings],
          },
          {
            title: 'Администрирование',
            icon: 'user-shield',
            to: '/administration',
            hideOnMobile: false,
            permissions: [CRMPermission.ViewAdministration],
          },
        ]
      },
    },
    methods: {
      userCanAccessToRoute (item) {
        if (item.roles) {
          return this.userIs(item.roles)
        }

        if (
          this.isMobileScreen &&
          !_.isEmpty(item.mobilePermissions) &&
          !this.userCan(item.mobilePermissions)
        ) {
          return false
        }

        if (item.permissions) {
          return this.userCan(item.permissions)
        }

        return true
      },
    },
  }
</script>

<style lang="less" scoped>
.drawer-links-component {
  margin-bottom: 0px;

  .aside-list {
    padding: 0 !important;

    .media-sm({
      padding-bottom: 20px !important;
    });
  }

  .media-lg({
    .hide-on-mobile {
      display: none !important;
    }
  });

  /*.media-xl-max({
    margin-bottom: 0;
  });*/
}
</style>
